import React, { useEffect, useState } from 'react'
import LiveTime from './LiveTime'

function Footer() {

    return (
        <div>
            <footer className='bg-gray-900  p-3'>

                <div className="container mx-auto text-center">
                    <p className='font-semibold text-white'>
                        © <span><LiveTime formatOptions={{ year: 'numeric' }} /></span> Mandap Booking Portal
                    </p>
                </div>
            </footer>
        </div>

    )
}

export default Footer